import DefaultLayout from 'components/layout/DefaultLayout';
import { useAuth } from 'hooks/auth/AuthElement';
import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

type Rule = string;

interface ProtectedRouteProps {
  element: ReactNode;
  rule?: Rule;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, rule }) => {
  const { checkAuth } = useAuth();

  return <>{checkAuth() ? <DefaultLayout>{element}</DefaultLayout> : <Navigate to="/login" />}</>;
};

export default ProtectedRoute;
